export const validateFeatureBranchUrl = (url) => {
  if (!url) return false

  const re = /.*\.fb.blaze.me/
  const matched = url.search(re)
  if (matched === -1) return false
  return true
}



// WEBPACK FOOTER //
// ./src/utils/validateFeatureBranch.js